export default "__VITE_ASSET__CfskO3AW__"